<template>
  <div class="question question-mobile question-exam-mobile">
    <div v-if="questions && questions.length > 0" class="question__list">
      <div
        v-for="(item, index) of questions"
        :key="index"
        :id="`question_item_${item.questionId}`"
        class="item position-rel content-1"
        :class="{'evt-none': examInfo && ((examInfo.isWork && examInfo.isWork === statusExamDone) || examInfo.isEndTime)}"
      >
          <div class="question-group" v-if="item && item.type && item.type === typeGroup">
            <PreviewQuestion 
              :dataSource="item"
              :questions="questions"
              :location="positionQuestionWork"
              :preview="true"
              :questionsData="item"
              :isListQuestion="true"
              :isDontShowResultSaved="isDontShowResultWorking"
              :isShowTitle="true"
              @formatQuestion="getInfoQuestion"
              @getResultQuestion="getResultQuestion"
              @answerMissing="handleAnswerMissing"
            />
            <div class="questions-child" v-if="item.listQuestionChild">
              <div class="questions-child__item" v-for="(child, pos) of item.listQuestionChild">
                <PreviewQuestion 
                  v-if="child"
                  :dataSource="child"
                  :location="pos"
                  :parentIndex="index"
                  :isQuestionChild="true"
                  :preview="true"
                  :questionsData="item"
                  :questions="item.listQuestionChild"
                  :isListQuestion="true"
                  :isDontShowResultSaved="isDontShowResultWorking"
                  :isShowTitle="true"
                  @formatQuestion="getInfoQuestion"
                  @writedAnswer="handleWriteAnswer($event, item)"
                />
              </div>
            </div>
          </div>
          <div class="question-single" v-else-if="item">
            <PreviewQuestion 
              :dataSource="item"
              :location="positionQuestionWork"
              :preview="true"
              :isListQuestion="true"
              :isDontShowResultSaved="isDontShowResultWorking"
              :isShowTitle="true"
              @getResultQuestion="getResultQuestion"
              @formatQuestion="getInfoQuestion"
              @answerMissing="handleAnswerMissing"
              @writedAnswer="handleWriteAnswer"
            />
          </div>
      </div>
    </div>
    <p v-else class="secondary-color-txt font-size-20 text-center">Dữ liệu đang cập nhật</p>
    <div v-if="examInfo && examInfo.isWork && examInfo.isWork !== statusExamDone" class="question-action">
      <button type="button" @click="handleSendExamQuestions">Hoàn thành</button>
    </div>
  </div>
</template>

<script>
import { getExamDetail, saveQuestionExamWorked, sendExamWorked, getQuestionsExam } from './../_api/'
import { mapActions } from 'vuex'
import PreviewQuestion from './../_components/question/preview-question/PreviewQuestion.vue'
import { STORE_KEY as STORE_KEY_QUESTION, TYPE_RADIO, TYPE_GROUP } from './../_components/question/preview-question/_store/constants'
import { STORE_KEY, EXAM_WORKED_DONE } from "./../_store/constants"
import mixinExercise from './../_store/mixinExercise'
import { setContentMediaEditorShow } from '@/modules/question/preview-question/_store/helperQuestionContent'
import { callTimeDiff } from '@/helpers/functions'

export default {
  name: 'ExerciseExamDetail',
  components: {
    PreviewQuestion
  },
  mixins: [ mixinExercise ],
  data () {
    return {
      examInfo: {},
      questions: [],
      question: {},
      typeGroup: TYPE_GROUP,
      statusExamDone: EXAM_WORKED_DONE,
      positionQuestionWork: 0,
      arrResultCorrect: [],
      isDontShowResultWorking: true
    }
  },
  computed: {
    examId () {
      return parseInt(this.$route.params.id)
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('common', ['setLoading', 'setActionCheckQuestion']),
    ...mapActions(STORE_KEY_QUESTION, ['setQuestionData4CheckAnswer', 'setQuestionList4CheckAnswer']),

    async initPage () {
      // this.setLoading(true)
      let data = await Promise.all([getExamDetail(this.examId), getQuestionsExam(this.examId)])
      this.examInfo = data[0] && data[0].data ? data[0].data : {}
      data[1] && data[1].data && this.setQuestionExamInit(data[1].data)
      // this.questions = data[1] && data[1].data ? data[1].data : []

      this.isDontShowResultWorking = data[0] && data[0].data && data[0].data.isWork === EXAM_WORKED_DONE ? false : true
      this.setLoading(false)
    },

    setQuestionExamInit (questionsData) {
      let questionReplaceContent = questionsData.map(ques => {
        let typeQuestion = ques.type === TYPE_GROUP ? 'group' : 'single'
        ques = setContentMediaEditorShow({...ques}, typeQuestion)
        return ques
      })

      this.questions = questionReplaceContent
    },

    getInfoQuestion() {
      // let self = this;
      // self.question = null;
      //   self.setLoading(true);
      //   let questionId = self.questionList[self.questionCurr - 1].questionId;
      //   let questionsLocalStorage = JSON.parse(localStorage.getItem(LOCAL_SAVE_QUESTIONS_WORKED));

      //   if(questionsLocalStorage && questionsLocalStorage !== null && questionsLocalStorage !== undefined && questionsLocalStorage.length > 0) {
      //     let indexQuestionSave = questionsLocalStorage.findIndex(ques => ques.questionId === questionId);
      //     if(indexQuestionSave > -1) {
      //       self.question = questionsLocalStorage[indexQuestionSave];
      //       self.setLoading(false);
      //     } else {
      //       self.getQuestionDetail(questionId, questionsLocalStorage);
      //     }
      //   } else {
      //     self.getQuestionDetail(questionId);
      //   }
    },

    getQuestionDetail(questionId, dataQuestion = []) {
      // let self = this;
      // // Get question detail
      // getQuestionDetail(questionId).then(res => {
      //   if(res && res.data && !res.errors) {
      //     self.question = res.data
      //     let dataSave = dataQuestion.length === 0 ? [res.data] : [...dataQuestion, res.data]
      //     self.saveLocalQuestion(dataSave)
      //   }
      // }).catch().finally(() => self.setLoading(false))
    },

    handleWriteAnswer (val, parent = null) {
      let questionChildIndex = -1
      this.positionQuestionWork = this.questions.findIndex(ques => ques.questionId === (parent ? parent.questionId : val.question.questionId))
      if (this.positionQuestionWork === -1) {
        return;
      }

      if (parent) {
        questionChildIndex = parent.listQuestionChild.findIndex(child => child.questionId === val.question.questionId)
      }
      // console.log(indexQuestionWork);
      this.questions[this.positionQuestionWork]['statusWorked'] = true

      if (questionChildIndex > -1) {
        parent.listQuestionChild[questionChildIndex]['answerChoosed'] = val.answers
        parent.listQuestionChild[questionChildIndex]['examId'] = this.examId
        this.setQuestionData4CheckAnswer({...parent.listQuestionChild[questionChildIndex]})
      } else {
        this.questions[this.positionQuestionWork]['answerChoosed'] = val.answers
        this.questions[this.positionQuestionWork]['examId'] = this.examId
      }

      if (parent && parent.listQuestionChild[questionChildIndex].type === TYPE_RADIO) {
        parent.listQuestionChild[questionChildIndex].answers.map(ans => {
          ans.answerContent = null
        })
      } else if (!parent && this.questions[this.positionQuestionWork].type === TYPE_RADIO) {
        this.questions[this.positionQuestionWork].answers.map(ans => {
          ans.answerContent = null
        })
      }

      if (parent && questionChildIndex > -1) {
        this.setQuestionData4CheckAnswer({...parent.listQuestionChild[questionChildIndex], isGroup: true, parent: parent.questionId})
      } else {
        // Reset parent answer
        this.setQuestionData4CheckAnswer({...this.questions[this.positionQuestionWork]})
      }
      this.setQuestionList4CheckAnswer([...this.questions])

      this.checkAnswer()
    },

    // fetchQuestionDetail () {
    //   if (!this.$route.params.id) {
    //     return
    //   }

    //   this.setLoading(true)
    //   getQuestionDetail(this.$route.params.id).then(res => {
    //     this.question = res ? res : {}
    //     this.setQuestionData4CheckAnswer({...res})
    //   }).finally(() => this.setLoading(false))
    // },

    handleAnswerMissing (valErr) {
      if(this.question.type === TYPE_GROUP) {
        this.txtMissingQuestionGroup = valErr
      }
    },

    async checkAnswer () {
      let self = this;
      await this.setActionCheckQuestion(true)
      // Save question worked into DB
      saveQuestionExamWorked({question: [this.questions[this.positionQuestionWork]], examId: this.examId})
    },

    async handleSendExamQuestions () {
      let self = this
      // self.setLoading(true)
      sendExamWorked({examId: self.examId}).then(res => {
        if(res && !res.errors) {
          self.examInfo.isWork = true
          self.replaceRoutePushToApp()
        }
      }).finally(() => self.setLoading(false))
    },

    getResultQuestion(val) {
      this.arrResultCorrect = val
    }
  }
}
</script>

<style lang="scss" scoped>
.question__list {
  >.item {
    &:not(:last-child) {
      margin-bottom: 50px;
    }
  }
}
.question-exam-mobile {
  margin-bottom: 50px;
}
</style>
